import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledHeader = styled.div`
  text-align: center;
  margin-bottom: ${spacing('mdlg')};

  @media (min-width: ${screen('md')}) {
    margin-bottom: ${spacing('xl2')};
  }

  ${Heading1} {
    font-family: ${fontFamily('sans')};
    margin-bottom: ${spacing('lg')};
  }

  p {
    font-size: ${fontSize('lg')};
    line-height: 1.6;

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('xl')};
      line-height: 1.5;
    }
  }
`;

export const StyledLogo = styled.div`
  max-width: 12.5rem;
  margin: 0 auto ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    margin-bottom: ${spacing('xl2')};
  }

  @media (min-width: ${screen('md')}) {
    max-width: 20rem;
  }
`;

export const StyledLogoManfred = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xs2')};
  padding-left: ${spacing('xl2')};
  font-size: ${fontSize('xs2')};
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  text-align: left;

  @media (min-width: ${screen('md')}) {
    padding-left: ${spacing('xl3')};
  }

  img {
    height: 35px;

    @media (min-width: ${screen('md')}) {
      height: 47px;
    }
  }
`;

export const StyledIcon = styled.div`
  color: ${color('positive_500')};
  margin-bottom: ${spacing('md')};
  svg {
    width: ${spacing('xl4')};
    height: ${spacing('xl4')};
    @media (min-width: ${screen('md')}) {
      width: ${spacing('xl5')};
      height: ${spacing('xl5')};
    }
  }
`;
